import type { RoleConfig } from '../types.js';

export const vigilante: RoleConfig = {
  id: 'vigilante',
  faction: 'town',
  title: { ru: 'Линчеватель', uk: 'Лінчувач' },
  latin: 'VIGILANTE',
  number: '13',
  accent: '#ff5a3a',
  ability: {
    ru: 'Один раз за игру публично казнит выбранного игрока. Дневное действие.',
    uk: 'Один раз за гру публічно страчує обраного гравця. Денна дія.',
  },
  abilities: [
    { key: 'execute', phase: 'day', cadence: 'one-time', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
